import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';

import { DEFAULT_SITE_DESCRIPTION, DEFAULT_SITE_KEYWORDS, OgType, SITE_LOGO, SITE_NAME, SITE_URL } from '@app/types/seo.types';
import { ScrollService } from '@app/common/services/scroll.service';
import { SeoService } from '@app/common/services/seo.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-legal-info',
  imports: [RouterLink],
  templateUrl: './legal-info-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './legal-info-page.component.scss'
})
export class LegalInfoPageComponent implements OnInit {
  private scrollService = inject(ScrollService);
  private seoService = inject(SeoService);

  ngOnInit(): void {
    this.seoService.setSeoData({
      title: 'Informacje prewne',
      description: DEFAULT_SITE_DESCRIPTION,
      keywords: DEFAULT_SITE_KEYWORDS,
      ogImage: {
        url: SITE_LOGO,
        alt: `${SITE_NAME} Logo`
      },
      ogUrl: SITE_URL,
      ogType: OgType.Article
    });
    this.scrollService.scrollToTop();
  }
}
